// removed by extract-text-webpack-plugin
module.exports = {"Card":"TCYw1YIPv_J1DIo0pDwob","CardBody":"_2TKqbsiFBRFNGrACtl4n5x","FiltersRow":"_2YuhvdToS4e6alRDGUazAM","FilterGroup":"_20lDBV_uICP0SvLs3Ibojg","Label":"_35D9ow7EKuoASB7ik048Fh","Select":"AqOLohlXEUfJ-e6FQvjAU","Input":"-EJlWkavTO0bz_7k_idmE","Actions":"zTdm2-JQiV4dZFvFITQPl","BtnPrimary":"_2cSts0wBWD2VbBC4q22BpJ","BtnSecondary":"_1MAETvQVJ-GPmlwYDNBTIX"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/AuditLogsFilters/styles.module.css
// module id = 533
// module chunks = 0